import React, { Component } from "react";
import { Button, Modal, Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import NumberFormat from "react-number-format";
import moment from "moment";
import Workbook from "react-excel-workbook-emptystring";

class ExportaExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showExportar: "none",
    };
  }

  componentDidMount() {}

  render() {
    const { data, pages, loading, pageSize, currentPage } =
      this.props.viewModel.state;

    return (
      <div>
        <div className="btn-group">
          <button
            type="button"
            className="btn round7 bgColor2 fontColor5 hmargin5"
            onClick={() =>
              this.setState({
                showExportar: this.state.showExportar === "none" ? "block" : "none",
              })
            }>
            <i className="fa fa-share"></i>&nbsp;
            <span className="hidden-480">Exportar</span>&nbsp;
            <i className="fa fa-angle-down"></i>
          </button>
          <ul className="dropdown-menu pull-right" style={{ display: this.state.showExportar }}>
            <li style={{ padding: 5 }}>
              {
                <Workbook
                  filename={`corridas_${currentPage}.xlsx`}
                  element={
                    <button
                      type="button"
                      className="link-button"
                      href
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      style={{ margin: 5 }}>
                      <i className="fa fa-file-excel-o"></i>
                      Excel Completo
                    </button>
                  }>
                  <Workbook.Sheet data={data} name="Corridas">
                    <Workbook.Column label="Número" value="t12_num_corrida" width={20} />
                    <Workbook.Column label="Data" value={row => moment(row.t12_dthr_corridas).format("DD/MM/YYYY HH:mm")} width={20} />
                    <Workbook.Column label="Passageiro" value="t12_nome" width={20} />
                    <Workbook.Column label="Endereço" value="t12_endereco" width={20} />
                    <Workbook.Column label="Valor" value="valorcalculado" width={20} />
                    <Workbook.Column label="Centro de custo" value="voucher_departamento_identificacao" width={20} />
                    <Workbook.Column label="Descrição" value="voucher_departamento_descricao" width={20} />
                    <Workbook.Column label="Status" value="ztatus3" width={20} />
                  </Workbook.Sheet>
                </Workbook>
              }
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default ExportaExcel;
